import React from 'react';
import Subtopics from './Subtopics';
import { Container } from "react-bootstrap";
import {
    Switch,
    Route,
    Link,
    useRouteMatch
  } from "react-router-dom";

function Geometry(props) {
    let { path, url } = useRouteMatch();
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', maxWidth: "100vw"}}>
                {/* <SectionTitle title={props.topicId}/> */}
            <div style={{display: 'flex', flexDirection: 'row'}}> 
            <div style={{marginTop: '10px', marginRight: '0px', marginLeft: '5px',border: '3px', padding:'40px', paddingRight: '50px', borderStyle:'solid', borderColor:'grey', paddingLeft: '20px', whiteSpace:'nowrap'}}>
                <h2>Geometry</h2>
                <li>
                    <Link to={`${url}/trigonometry`}>Trigonometry</Link>
                </li>
                <li>
                    <Link to={`${url}/circles`}>Circles and Ellipses</Link>
                </li>
                <li>
                    <Link to={`${url}/parallelograms`}>Parallelograms</Link>
                </li>
                <li>
                    <Link to={`${url}/vectors`}>Vectors</Link>
                </li>          
                   <li>
                    <Link to={`${url}/threedgeometry`}>3D Geometry</Link>
                </li>      
                <li>
                    <Link to={`${url}/triangles`}>Triangles</Link>
                </li>  
                     <li>
                    <Link to={`${url}/coordinategeometry`}>Coordinate Geometry</Link>
                </li>     
                        <li>
                    <Link to={`${url}/curvesandcurvature`}>Curves & Curvature</Link>
                </li>     
                       <li>
                    <Link to={`${url}/centroids`}>Centroids</Link>
                </li>    
                </div>
                
            <Container>
                <Switch>
                    <Route exact path={path}>
                    <h3>Please select a sub-topic.</h3>
                    </Route>
                    <Route path={`${path}/:topicId`}>
                        <Subtopics />
                    </Route>
                </Switch>
            </Container>
         
                    </div>
            </div>
        </div>
    );
};

export default Geometry; 